/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CreateMachineFromReviewRequest from '../model/CreateMachineFromReviewRequest';
import Error from '../model/Error';
import MachineFile from '../model/MachineFile';
import MachineFileRevision from '../model/MachineFileRevision';
import MachineFileRevisionMeta from '../model/MachineFileRevisionMeta';
import OpenReviewsNotification from '../model/OpenReviewsNotification';
import ReassignMachineFileReviewRequest from '../model/ReassignMachineFileReviewRequest';

/**
* MachineFiles service.
* @module api/MachineFilesApi
* @version 0.0.1
*/
export default class MachineFilesApi {

    /**
    * Constructs a new MachineFilesApi. 
    * @alias module:api/MachineFilesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createMachineFromReview operation.
     * @callback module:api/MachineFilesApi~createMachineFromReviewCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} uuid The machine file uuid to create a machine from
     * @param {module:model/CreateMachineFromReviewRequest} createMachineFromReviewRequest 
     * @param {module:api/MachineFilesApi~createMachineFromReviewCallback} callback The callback function, accepting three arguments: error, data, response
     */
    createMachineFromReview(uuid, createMachineFromReviewRequest, callback) {
      let postBody = createMachineFromReviewRequest;
      // verify the required parameter 'uuid' is set
      if (uuid === undefined || uuid === null) {
        throw new Error("Missing the required parameter 'uuid' when calling createMachineFromReview");
      }
      // verify the required parameter 'createMachineFromReviewRequest' is set
      if (createMachineFromReviewRequest === undefined || createMachineFromReviewRequest === null) {
        throw new Error("Missing the required parameter 'createMachineFromReviewRequest' when calling createMachineFromReview");
      }

      let pathParams = {
        'uuid': uuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/machine-file/{uuid}/review/create-machine', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the discardMachineFileReview operation.
     * @callback module:api/MachineFilesApi~discardMachineFileReviewCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} uuid The machine file uuid to discard
     * @param {Object} opts Optional parameters
     * @param {Object} [body] 
     * @param {module:api/MachineFilesApi~discardMachineFileReviewCallback} callback The callback function, accepting three arguments: error, data, response
     */
    discardMachineFileReview(uuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'uuid' is set
      if (uuid === undefined || uuid === null) {
        throw new Error("Missing the required parameter 'uuid' when calling discardMachineFileReview");
      }

      let pathParams = {
        'uuid': uuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/machine-file/{uuid}/review/discard', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAllMachinesInformationForOpenReviewsNotification operation.
     * @callback module:api/MachineFilesApi~getAllMachinesInformationForOpenReviewsNotificationCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/OpenReviewsNotification>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/MachineFilesApi~getAllMachinesInformationForOpenReviewsNotificationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/OpenReviewsNotification>}
     */
    getAllMachinesInformationForOpenReviewsNotification(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [OpenReviewsNotification];
      return this.apiClient.callApi(
        '/machine-file/open-reviews/all', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getMachineFileHistory operation.
     * @callback module:api/MachineFilesApi~getMachineFileHistoryCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MachineFileRevisionMeta>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} machineId The machine serial to load the data for
     * @param {module:api/MachineFilesApi~getMachineFileHistoryCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MachineFileRevisionMeta>}
     */
    getMachineFileHistory(machineId, callback) {
      let postBody = null;
      // verify the required parameter 'machineId' is set
      if (machineId === undefined || machineId === null) {
        throw new Error("Missing the required parameter 'machineId' when calling getMachineFileHistory");
      }

      let pathParams = {
        'machineId': machineId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [MachineFileRevisionMeta];
      return this.apiClient.callApi(
        '/machine-file/history/{machineId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getMachineFileOpenForReview operation.
     * @callback module:api/MachineFilesApi~getMachineFileOpenForReviewCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MachineFile} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} machineSerial The serial of the machine to return
     * @param {String} machineFileUuid The uuid of the machine-file entry to return
     * @param {module:api/MachineFilesApi~getMachineFileOpenForReviewCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MachineFile}
     */
    getMachineFileOpenForReview(machineSerial, machineFileUuid, callback) {
      let postBody = null;
      // verify the required parameter 'machineSerial' is set
      if (machineSerial === undefined || machineSerial === null) {
        throw new Error("Missing the required parameter 'machineSerial' when calling getMachineFileOpenForReview");
      }
      // verify the required parameter 'machineFileUuid' is set
      if (machineFileUuid === undefined || machineFileUuid === null) {
        throw new Error("Missing the required parameter 'machineFileUuid' when calling getMachineFileOpenForReview");
      }

      let pathParams = {
        'machineSerial': machineSerial,
        'machineFileUuid': machineFileUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = MachineFile;
      return this.apiClient.callApi(
        '/machine-file/{machineSerial}/review/{machineFileUuid}/data', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getMachineFileRevision operation.
     * @callback module:api/MachineFilesApi~getMachineFileRevisionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MachineFileRevision} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} machineId The ID of the machine
     * @param {Number} revision The revision of the machine file
     * @param {module:api/MachineFilesApi~getMachineFileRevisionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MachineFileRevision}
     */
    getMachineFileRevision(machineId, revision, callback) {
      let postBody = null;
      // verify the required parameter 'machineId' is set
      if (machineId === undefined || machineId === null) {
        throw new Error("Missing the required parameter 'machineId' when calling getMachineFileRevision");
      }
      // verify the required parameter 'revision' is set
      if (revision === undefined || revision === null) {
        throw new Error("Missing the required parameter 'revision' when calling getMachineFileRevision");
      }

      let pathParams = {
        'machineId': machineId,
        'revision': revision
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = MachineFileRevision;
      return this.apiClient.callApi(
        '/machine-file/history/{machineId}/{revision}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSpecificMachineInformationForOpenReviewsNotification operation.
     * @callback module:api/MachineFilesApi~getSpecificMachineInformationForOpenReviewsNotificationCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/OpenReviewsNotification>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} machineSerial The machine serial to load the data for
     * @param {module:api/MachineFilesApi~getSpecificMachineInformationForOpenReviewsNotificationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/OpenReviewsNotification>}
     */
    getSpecificMachineInformationForOpenReviewsNotification(machineSerial, callback) {
      let postBody = null;
      // verify the required parameter 'machineSerial' is set
      if (machineSerial === undefined || machineSerial === null) {
        throw new Error("Missing the required parameter 'machineSerial' when calling getSpecificMachineInformationForOpenReviewsNotification");
      }

      let pathParams = {
        'machineSerial': machineSerial
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [OpenReviewsNotification];
      return this.apiClient.callApi(
        '/machine-file/open-reviews/{machineSerial}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the markMachineFileAsReviewed operation.
     * @callback module:api/MachineFilesApi~markMachineFileAsReviewedCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} uuid The machine file uuid that has been reviewed
     * @param {Object} opts Optional parameters
     * @param {Object} [body] 
     * @param {module:api/MachineFilesApi~markMachineFileAsReviewedCallback} callback The callback function, accepting three arguments: error, data, response
     */
    markMachineFileAsReviewed(uuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'uuid' is set
      if (uuid === undefined || uuid === null) {
        throw new Error("Missing the required parameter 'uuid' when calling markMachineFileAsReviewed");
      }

      let pathParams = {
        'uuid': uuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/machine-file/{uuid}/review/accept', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the reassignMachineFileReview operation.
     * @callback module:api/MachineFilesApi~reassignMachineFileReviewCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} uuid The machine file uuid to reassign
     * @param {module:model/ReassignMachineFileReviewRequest} reassignMachineFileReviewRequest 
     * @param {module:api/MachineFilesApi~reassignMachineFileReviewCallback} callback The callback function, accepting three arguments: error, data, response
     */
    reassignMachineFileReview(uuid, reassignMachineFileReviewRequest, callback) {
      let postBody = reassignMachineFileReviewRequest;
      // verify the required parameter 'uuid' is set
      if (uuid === undefined || uuid === null) {
        throw new Error("Missing the required parameter 'uuid' when calling reassignMachineFileReview");
      }
      // verify the required parameter 'reassignMachineFileReviewRequest' is set
      if (reassignMachineFileReviewRequest === undefined || reassignMachineFileReviewRequest === null) {
        throw new Error("Missing the required parameter 'reassignMachineFileReviewRequest' when calling reassignMachineFileReview");
      }

      let pathParams = {
        'uuid': uuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/machine-file/{uuid}/review/reassign', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
